// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","logo":"header_logo__wLirW","btns_box":"header_btns_box__-8dFL","hidden":"header_hidden__gbYee"};